import { useState } from "react";
import { useForm } from "react-hook-form";

import { toast } from "react-toastify";
import { obtenerPersona } from "./handlers";
import InfoPerson from "./InfoPerson";

const BuscarPersona = ({ show, onUserSelect }) => {
  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = useForm();
  const [persona, setPersona] = useState(null);

  const onSubmit = async (form) => {
    obtenerPersona(form, setPersona);
  };

  const handleSelectPerson = () => {
    if (persona) {
      if (persona.informacion.usuarioID === 0) {
        toast.error("La persona no posee usuario");
      } else {
        const selectedUser = {
          id: persona.informacion.usuarioID,
          roles: [],
        };
        onUserSelect(selectedUser);
      }
    }
  };

  if (!show) return null;

  return (
    <div className=" mt-4">
      <form onSubmit={handleSubmit(onSubmit)} className="row g-3 align-items-end">
        <div className="col-md-8">
          <label htmlFor="documento" className="form-label">
            Número de DNI
          </label>
          <input
            type="text"
            className="form-control"
            id="documento"
            {...register("documento")}
            name="documento"
          />
        </div>
        <div className="col-md-4">
          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
            {isSubmitting ? "Buscando..." : "Buscar"}
          </button>
        </div>
      </form>
      {persona && (
        <div className="mt-4">
          <InfoPerson persona={persona.informacion} onSelect={handleSelectPerson} />
        </div>
      )}
    </div>
  );
};

export default BuscarPersona;
